module.exports = __webpack_public_path__ + "img/alvox.fb9fb08a.png";